// /src/components/moodle/Forum/forms/AddPostForm.tsx
import React, { useState } from 'react';

type Props = {
  onSubmit: (payload: { subject: string; message: string }) => void;
  submitting?: boolean;
  onBack?: () => void;
};

export default function AddPostForm({ onSubmit, submitting, onBack }: Props) {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');

  return (
    <form
      className="composer"
      onSubmit={(e) => {
        e.preventDefault();
        if (!subject || !message) return;
        onSubmit({ subject, message });
        setSubject('');
        setMessage('');
      }}
    >
      <div className="composer-title">Reply to discussion</div>
      <div className="field">
        <label className="label" htmlFor="rp-subject">Subject</label>
        <input
          id="rp-subject"
          className="input"
          type="text"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
        />
      </div>
      <div className="field">
        <label className="label" htmlFor="rp-message">Message</label>
        <textarea
          id="rp-message"
          className="textarea"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          required
          rows={5}
        />
      </div>
      <div className="actions">
        <button type="submit" className="btn btn-primary" disabled={submitting}>
          {submitting ? 'Posting…' : 'Post Reply'}
        </button>
        {onBack && (
          <button type="button" className="btn" onClick={onBack}>
            Back
          </button>
        )}
      </div>

      <style>
        {`
          .composer { border:1px solid rgba(0,0,0,0.12); border-radius:10px; background:#fff; padding: var(--hbr-spacing-md); margin-bottom: var(--hbr-spacing-lg); }
          .composer-title { font-family: var(--hbr-font-body); font-weight: var(--hbr-font-weight-semibold); margin-bottom: var(--hbr-spacing-sm); }
          .field { margin-bottom: var(--hbr-spacing-sm); }
          .label { display:block; margin-bottom: var(--hbr-spacing-2xs); font-family: var(--hbr-font-body); font-size: var(--hbr-font-size-sm); font-weight: var(--hbr-font-weight-semibold); }
          .input, .textarea { width:100%; padding:0.8rem 1rem; border-radius:10px; border:1px solid rgba(0,0,0,0.2); background:#fff; font-family:var(--hbr-font-body); font-size: var(--hbr-font-size-md); }
          .actions { margin-top: var(--hbr-spacing-sm); display:flex; gap: var(--hbr-spacing-sm); }
          .btn { display:inline-flex; align-items:center; justify-content:center; gap: var(--hbr-spacing-2xs); padding:0.6rem 1rem; border-radius:10px; border:1px solid transparent; cursor:pointer; font-family:var(--hbr-font-body); font-size: var(--hbr-font-size-sm); font-weight: var(--hbr-font-weight-semibold); }
          .btn-primary { background:#0a66ff; color:#fff; }
          .btn-primary:hover { background:#004fe0; }
        `}
      </style>
    </form>
  );
}